import {Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, ScrollView, StyleSheet, View} from 'react-native';
import {starBanner} from '../../../assets/images';
import {hp, useIsLandscape, wp} from '../../../utils';
import TitleRow from '../TitleRow';
import PageHeader from './PageHeader';

const Page = ({
  children,
  header: {
    title,
    accessoryRight,
    showDrawerAction,
    showBackAction,
    onModalBackPressed,
  } = {},
  scrollViewStyle,
  useModalView = false,
  useSidebarView = false,
}) => {
  const isLandscape = useIsLandscape();

  if (useModalView) {
    return (
      <Modal
        visible={true}
        backdropStyle={styles.modalBackdrop}
        onBackdropPress={onModalBackPressed}>
        <Card disabled={true}>
          <Layout
            style={{width: isLandscape ? wp(40) : wp(90), maxHeight: hp(90)}}>
            <TitleRow
              title={title}
              type="primary"
              leftIconName="arrow-ios-back-outline"
              onLeftIconClick={onModalBackPressed}
              containerStyle={styles.modalTitle}
            />
            <ScrollView contentContainerStyle={scrollViewStyle}>
              {children}
            </ScrollView>
          </Layout>
        </Card>
      </Modal>
    );
  }

  if (useSidebarView) {
    return (
      <Layout style={styles.container}>
        <TitleRow
          title={title}
          type="primary"
          leftIconName="arrow-ios-back-outline"
          onLeftIconClick={onModalBackPressed}
          containerStyle={styles.modalTitle}
        />
        <ScrollView contentContainerStyle={scrollViewStyle}>
          {children}
        </ScrollView>
      </Layout>
    );
  }

  if (isLandscape) {
    return (
      <Layout style={styles.landscapeOutsideContainer}>
        <PageHeader
          accessoryRight={() => (
            <View style={styles.imageBox}>
              <Image
                source={starBanner}
                resizeMode="contain"
                style={styles.image}
              />
            </View>
          )}
          showDrawerAction={false}
          showBackAction={false}
        />
        <Text style={styles.title}>{title}</Text>
        <Layout style={styles.landscapeInnerContainer}>
          <ScrollView contentContainerStyle={scrollViewStyle}>
            {children}
          </ScrollView>
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout style={styles.container}>
      <PageHeader
        title={title}
        accessoryRight={accessoryRight}
        showDrawerAction={showDrawerAction}
        showBackAction={showBackAction}
      />
      <ScrollView contentContainerStyle={scrollViewStyle}>
        {children}
      </ScrollView>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  landscapeOutsideContainer: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  landscapeInnerContainer: {
    flex: 1,
    marginHorizontal: 20,
    marginVertical: 24,
    borderRadius: 4,
  },
  title: {
    fontWeight: '700',
    fontSize: 24,
    marginTop: 24,
    marginLeft: 20,
  },
  imageBox: {
    padding: 7,
    backgroundColor: '#fff',
    borderRadius: wp(50),
    marginRight: 10,
  },
  image: {
    width: 35,
    height: 35,
  },
  modalBackdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  modalTitle: {
    width: '100%',
  },
});

export default Page;
